import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import {
  AsignacionCurso,
  AsignarCursoDto,
  CreateCursoDto,
  Curso,
  FirmarCursoDto,
  ProgresoCurso,
  ProgresoResponse,
  ProgresoUsuariosResponse,
  UpdateCursoDto,
} from './types/cursos.types';

export class CursosService {
  static async create(dto: CreateCursoDto): Promise<Curso> {
    const response: AxiosResponse<Curso> = await AxiosService.post('/cursos', dto);
    return response.data;
  }

  static async findAll(): Promise<Curso[]> {
    const response: AxiosResponse<Curso[]> = await AxiosService.get('/cursos');
    return response.data;
  }

  static async misCursos(): Promise<Curso[]> {
    const response: AxiosResponse<Curso[]> = await AxiosService.get('/cursos/mis-cursos');
    return response.data;
  }

  static async findOne(id: string): Promise<Curso> {
    const response: AxiosResponse<Curso> = await AxiosService.get(`/cursos/${id}`);
    return response.data;
  }

  static async update(id: string, dto: UpdateCursoDto): Promise<Curso> {
    const response: AxiosResponse<Curso> = await AxiosService.patch(`/cursos/${id}`, dto);
    return response.data;
  }

  static async remove(id: string): Promise<void> {
    await AxiosService.delete(`/cursos/${id}`);
  }

  static async asignar(cursoId: string, dto: AsignarCursoDto): Promise<AsignacionCurso> {
    const response: AxiosResponse<AsignacionCurso> = await AxiosService.post(`/cursos/${cursoId}/asignaciones`, dto);
    return response.data;
  }

  static async listAsignaciones(cursoId: string): Promise<AsignacionCurso[]> {
    const response: AxiosResponse<AsignacionCurso[]> = await AxiosService.get(`/cursos/${cursoId}/asignaciones`);
    return response.data;
  }

  static async removeAsignacion(asignacionId: string): Promise<void> {
    await AxiosService.delete(`/cursos/asignaciones/${asignacionId}`);
  }

  static async getProgreso(cursoId: string): Promise<ProgresoResponse> {
    const response: AxiosResponse<ProgresoResponse> = await AxiosService.get(`/cursos/${cursoId}/progreso`);
    return response.data;
  }

  static async getProgresoUsuarios(cursoId: string): Promise<ProgresoUsuariosResponse> {
    const response: AxiosResponse<ProgresoUsuariosResponse> = await AxiosService.get(
      `/cursos/${cursoId}/progreso-usuarios`,
    );
    return response.data;
  }

  static async firmar(cursoId: string, dto: FirmarCursoDto): Promise<ProgresoCurso> {
    const response: AxiosResponse<ProgresoCurso> = await AxiosService.post(`/cursos/${cursoId}/firmar`, dto);
    return response.data;
  }

  static async descargarCertificado(cursoId: string): Promise<Blob> {
    const response: AxiosResponse<Blob> = await AxiosService.get(`/cursos/${cursoId}/certificado`, {
      responseType: 'blob',
    });
    return response.data;
  }

  static async descargarResultados(cursoId: string, soloCompletados: boolean): Promise<Blob> {
    const response: AxiosResponse<Blob> = await AxiosService.get(`/cursos/${cursoId}/resultados`, {
      params: { soloCompletados },
      responseType: 'blob',
    });
    return response.data;
  }

  static async reiniciarCurso(cursoId: string): Promise<{ reiniciados: number }> {
    const response: AxiosResponse<{ reiniciados: number }> = await AxiosService.post(
      `/cursos/${cursoId}/reiniciar`,
      {},
    );
    return response.data;
  }
}
